import React, { useReducer, useState } from "react";
import { SimpleInput } from "../../components/Inputs/SimpleInput";
import { AFIO } from "./../../utils/AsyncFetch/AsyncFetch";
import jdata from "./json/validatorData.json";
import { ROICalculator } from "../ROICalculator/Calculator";
import { GridContainer, GridItem } from "../../components/Grid/Grid";
import Swal from "sweetalert2";
import "./scss/contact.scss";
import svgRoute from "../../assets/img/ruta.svg";
import { ReactSVG } from "react-svg";

/*eslint eqeqeq: 0*/
export function ContactForm({ roiData, ...rest }) {
  const {
    perLiter,
    gasPrice,
    maintenancePrice,
    salary,
    monthlySavings,
    unitsSpare,
    vehicles,
    type,
  } = roiData;
  const [loading, toggle] = useState(0);
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      Description: "",
      LEADCF21: type,
      Company: "",
      firstName: "",
      lastName: "",
      Email: "",
      Phone: "",
      LEADCF20: vehicles,
      LEADCF57: vehicles, //num cars
      LEADCF55: perLiter, // prom cars
      LEADCF67: gasPrice, // litro gas
      LEADCF66: maintenancePrice, //Gasto mensual mtto vehículo
      LEADCF68: salary, //Sueldo mensual conductor
      LEADCF69: monthlySavings, // Ahorros mensuales
      LEADCF56: unitsSpare, // Unidades de reparto y personal ahorradas
    }
  );
  const { Description, Company, firstName, lastName, Email, Phone } = state;
  return (
    <form
      className="contactForm"
      onSubmit={(ev) => {
        ev.preventDefault();
        const fetch = new AFIO("https://crm.zoho.com/crm/WebToLeadForm");
        let inputs = state;
        toggle(1);
        inputs["First Name"] = state.firstName;
        inputs["Last Name"] = state.firstName;
        fetch.post({ ...inputs, ...jdata }).then(() => {
          toggle(0);
          Swal.fire(
            "Completado",
            "Un ejecutivo se pondra en contacto en la brevedad posible",
            "success"
          );
          setTimeout(() => {
            window.location.href = jdata.returnURL;
          }, 2000);
        });
      }}
    >
      <h2>Formulario de contacto</h2>
      <SimpleInput
        required
        type="text"
        onChange={({ target }) => {
          setState({ firstName: target.value });
        }}
        value={firstName}
        title="Nombre"
      />
      <SimpleInput
        required
        type="text"
        onChange={({ target }) => {
          setState({ lastName: target.value });
        }}
        value={lastName}
        title="Apellido"
      />
      <SimpleInput
        required
        type="text"
        onChange={({ target }) => {
          setState({ Company: target.value });
        }}
        value={Company}
        title="Empresa"
      />
      <SimpleInput
        required
        type="email"
        onChange={({ target }) => {
          setState({ Email: target.value });
        }}
        value={Email}
        title="Correo"
      />
      <SimpleInput
        required
        type="tel"
        onChange={({ target }) => {
          setState({ Phone: target.value });
        }}
        value={Phone}
        title="Teléfono"
      />
      <SimpleInput
        required
        type="text"
        onChange={({ target }) => {
          setState({ Description: target.value });
        }}
        value={Description}
        title="Descripcion"
      />
      {loading ? <h3>Cargando...</h3> : <button>Enviar</button>}
    </form>
  );
}
export function ContactFlux() {
  const [data, setData] = useState({});
  const [openForm, toggle] = useState(0);
  let isDataFilled = () => {
    for (let key in data) {
      if (key == "type") {
        continue;
      }
      let val = !isNaN(data[key]) ? data[key] : 0;

      if (val <= 0) return false;
    }
    return true;
  };
  let aproved = () => {
    return isDataFilled(data) && data.vehicles >= 30;
  };
  let isAproved = aproved(data);

  return (
    <div className="flux">
      <GridContainer>
        <GridItem md={8}>
          <ROICalculator
            onChange={(values) => {
              setData({ ...values });
            }}
          />
        </GridItem>
        <GridItem
          md={4}
          style={{
            backgroundColor: "#aaa",
            padding: "15px",
            filter: `brightness(${isDataFilled(data) ? 1 : 0.5})`,
          }}
        >
          <h2>
            <span>3</span>Prueba de concepto
          </h2>
          {openForm ? (
            <ContactForm roiData={data} />
          ) : (
            <div className="actionArea">
              {" "}
              <span>
                ¿Quieres conocer los ahorros que <strong>Mapcel TMS</strong> te
                pudiera generar con mayor precisión ?
              </span>
              <button
                onClick={() => {
                  toggle(1);
                }}
              >
                {isAproved ? "Registrar mi prueba" : "Continuar"}
              </button>
              {isAproved ? (
                <center>
                  <h2>¡Felicidades!</h2>
                  <h3>Calificaste para una prueba de concepto gratuita</h3>
                </center>
              ) : (
                ""
              )}
            </div>
          )}
          <div className="ruta">
            <ReactSVG src={svgRoute} />
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
